






















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxButton, DxTextBox,DxCheckBox } from 'devextreme-vue';
import CheckBox from 'devextreme/ui/check_box';
import { Prop } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxPopover, { DxToolbarItem } from 'devextreme-vue/popover';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { InfractionDto } from '../../models/infractions/InfractionDto';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { InfractionModel } from '../../models/infractions/InfractionModel';
import {InfractionCacheModel } from '../../models/infractions/InfractionCacheModel';
import { InfractionService } from '@/service/InfractionService';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import DxList from 'devextreme-vue/list';
import _ from 'lodash';
import { ManualCodeInvoiceLineItemDto } from '../../models/ManualCodeInvoiceLineItemDto';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

@Component({
        components: {
            DxButton,
            DxPopover,
            DxScrollView,
            DxTextBox,
            DxLoadPanel,
            DxCheckBox,
            DxToolbar,
            DxItem,
            DxList
        }
    })
    export default class PhaseAssignmentInfractionsPopover extends Vue {
        @Prop({ default: false })
        popoverVisible!: boolean;

        get popoverVis(): boolean {
            return this.popoverVisible;
        }

        set popoverVis(value: boolean) {
            this.$emit('update:popoverVisible', value);
        }

        popoverVisibleTemp: boolean = false;

        @Watch('popoverVisible')
        onPropertyChanged(value: boolean, oldValue: boolean) {
           if (this.hideTimeout) {
             clearTimeout(this.hideTimeout);
             this.hideTimeout = undefined;
           }

           if (this.debounceTime) {
              clearTimeout(this.debounceTime);
              this.debounceTime = undefined;
           }

           if (!value) {
              this.debounceTime = setTimeout(this.handlePopoverHidingTimeout, 500);
           } else {
              this.popoverVisibleTemp = true;

              let comp = this.dxPopover;
              this.initFunc(comp);
           }
        }

        @Prop({ default: '' })
        popoverTarget!: string;

        get popoverTargetGet(): string {
            return this.popoverTarget;
        }

        @Prop({ required: true })
        lineItem!: ManualCodeInvoiceLineItemDto;

        @Prop({ required: true })
        infractionTypes!: InfractionTypeDto[];

        @Prop({ default: 'rgb(240, 240, 240)' })
        phaseColor!: string;

        private get dxPopover(): any {
          return ((this.$refs['dxPopover'] as any).instance as any);
        }

        private get dxListOfInfractions(): any {
            return (this.$refs['dxListOfInfraction'] as DxList).instance;
        }

        updated(): void {
            this.$nextTick(function() {
                this.handleScrollingToSelectedInfraction();
            });
        }
        
        active: boolean = false;
        debounceTime: number | undefined;
        listOfInfractionsPerLineItem: InfractionTypeDto[] = [];
        infractionService: InfractionService;
        infractionInfo: string = '';
        thisComponentHovered!: boolean;
        cacheData: InfractionCacheModel[] = [];

        constructor() {
            super();
            this.infractionService = new InfractionService();
            this.$root.$on('remove-popover-cache', this.handleRemoveCacheEventBus);
        }

        beforeDestroy() {
            this.$root.$off('remove-popover-cache', this.handleRemoveCacheEventBus);
        }

        handleScrollingToSelectedInfraction(): void {
            let selectedElement = document.getElementsByClassName('selected-infraction-popover')[0];
            if (selectedElement) {
                selectedElement.scrollIntoView(true);
            }
        }

        handleRemoveCacheEventBus(): void {
            this.removeCacheBasedFromSelectedLineId();
        }

        isSelectedInfractionClass(isConfirmed: boolean): string {
            let deft = 'dx-template-wrapper dx-item-content dx-list-item-content';
            return isConfirmed ? 'selected-infraction-popover ' + deft : deft;
        }

        initFunc(component: any): void {
            let popOverComponent = component;

            if (popOverComponent._$element) {
                let elem = popOverComponent._$element[0];

                if (elem && elem.children) {
                    let setEventElem = elem.children[0];

                    if (setEventElem) {
                        if (!setEventElem.onmouseenter) {
                            setEventElem.onmouseenter = this.mouseOver;
                        }
                        if (!setEventElem.onmouseleave) {
                            setEventElem.onmouseleave = this.mouseLeft;
                        }
                    }
                    
                }
            }
        }

        checkBoxComponent: any[] = [];
        onCheckBoxContentReady(e: any): void {
            this.checkBoxComponent.push(e.component);
        }
        
        onSelectedValueChanged(data: any): void {
            let a = data;
            let fond = _.find(this.checkBoxComponent, (item: any) => item === data.component);

            if (data.value) {
                let excludedElement = [];
                excludedElement.push(fond);

                let toUncheck = _.difference(this.checkBoxComponent, excludedElement);
                toUncheck.forEach((item: CheckBox) => {
                    item.option('value', false);
                });
            }
        }

        selectedInfraction: any[] = [];

        selectionOfInfraction(e: any): void {
            let elem = e.component;
            let items = elem.option().items;
            let isConfirmed = _.find(items, item => item.IsConfirmed);

            if (isConfirmed) {
                this.selectedInfraction = [];
                this.selectedInfraction.push(isConfirmed);
            }

            elem.option('selectedItems', this.selectedInfraction);
        }

        listSelectionChanged(e: any): void {
            let removeItem = e.removedItems ? e.removedItems[0] : undefined;
            let addedItem = e.addedItems ? e.addedItems[0] : undefined;
            let items = e.component.option().items;

            if (removeItem) {
                removeItem.IsConfirmed = false;
            }

            if (addedItem) {
                this.selectedInfraction = [];
                let prevSelected = _.find(items, item => item.IsConfirmed);
                let currenctSelected = _.find(items, item => item.InfractionTypeId == addedItem.InfractionTypeId);

                if (prevSelected) {
                    prevSelected.IsConfirmed = false;
                }

                if (currenctSelected) {
                    currenctSelected.IsConfirmed = true;
                }
                
                this.selectedInfraction.push(currenctSelected);
            }

            this.handleScrollingToSelectedInfraction();
        }

        onContentReady(e: any): void {
            this.selectionOfInfraction(e);
        }

        private hideTimeout: number | undefined;

        mouseLeft(): void {

            if (this.hideTimeout) {
              clearTimeout(this.hideTimeout);
            }

            this.hideTimeout = setTimeout(() => {
              this.listOfInfractionsPerLineItem = [];
              this.hidingPopover();
            }, 2000);
        }

        mouseOver(): void {

            if (this.hideTimeout) {
              clearTimeout(this.hideTimeout);
              this.hideTimeout = undefined;
            }

            this.thisComponentHovered = true;
        }

        handlePopoverHidingTimeout(): void {
            if (!this.thisComponentHovered) {
                this.hidingPopover();
            } else {
                this.popoverVisibleTemp = true;
            }
        }

        hiddenPopover(e: any) {
            this.listOfInfractionsPerLineItem = [];
            // this.hidingPopover();
        }

        hidPopover(e: any) {
            this.hidingPopover();
        }

        showingPopover(e: any): void {
            this.checkBoxComponent = [];
            this.listOfInfractionsPerLineItem = [];

            let infractions = _.cloneDeep(this.lineItem.Infractions);
            if (!infractions.length) {
              infractions = _.cloneDeep(this.infractionTypes);
            }

            this.listOfInfractionsPerLineItem = infractions;
        }

        private removeCacheBasedFromSelectedLineId(): void {
            if (this.cacheData) {
                _.remove(this.cacheData, data => data.key === this.lineItem.InvoiceLineItemId);
            }
        }

        private saveConfirm(): void {
            let lineItemId = this.lineItem.InvoiceLineItemId;
            let payload = '00000000-0000-0000-0000-000000000000';

            if (this.selectedInfraction && this.selectedInfraction.length > 0) {
                payload = this.selectedInfraction[0].InfractionTypeId;
            }

            this.infractionService.ConfirmInfractions(lineItemId, payload)
                .then(response => {
                    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.Infraction);
                    this.hidingPopover(false, response);
                })
                .catch(err => {});
        }

        hidingPopover(isCancelled: boolean = true, lineItem?: ManualCodeInvoiceLineItemDto): void {
            this.thisComponentHovered = false;
            this.popoverVisibleTemp = false;
            this.popoverVis = false;
            this.checkBoxComponent = [];
            this.$emit('hidingPopover', { isCancelled, lineItem });
        }
    }
